import { useEffect, useRef } from "react";
import queryString from "query-string";

import OneTrust from "shared/util/oneTrust";

const GOOGLE_ANALYTICS_SDK_URL = (() => {
	const queryParams = queryString.parse(window.location.search);
	const isDebugMode = queryParams.debug_ga === true;

	return `https://www.google-analytics.com/analytics${isDebugMode ? "_debug" : ""}.js`;
})();

const initGoogleAnalytics = () => {
	window.GoogleAnalyticsObject = "ga";
	window.ga = window.ga || ((...args) => {
		window.ga.q = window.ga.q || [];
		window.ga.q.push(args);
	});
	window.ga.l = 1 * new Date();

	return window.ga;
};

function useGoogleAnalytics({ userid, metroArea, location }) {
	// Initialize.
	const gaRef = useRef();
	useEffect(() => {
		gaRef.current = initGoogleAnalytics();

		OneTrust.loadScript(GOOGLE_ANALYTICS_SDK_URL, OneTrust.CATEGORY.ADVERTISING);
	}, []);

	// Login/out events.
	useEffect(() => {
		if (!gaRef.current) {
			return;
		}

		if (!userid) {
			gaRef.current("create", "UA-84707691-1", "auto");
			gaRef.current("set", "dimension2", "logged out");
		} else {
			gaRef.current("create", "UA-84707691-1", "auto", { userId: userid });
			gaRef.current("set", "dimension2", "logged in");
		}
	}, [userid, gaRef]);

	// Pageview events.
	useEffect(() => {
		if (!gaRef.current) {
			return;
		}

		gaRef.current("send", "pageview");
	}, [location.pathname, gaRef]);

	// Metadata.
	useEffect(() => {
		if (!gaRef.current || !metroArea) {
			return;
		}

		gaRef.current("set", "dimension1", metroArea);
	}, [metroArea]);
}

export default useGoogleAnalytics;



// WEBPACK FOOTER //
// ./src/routers/shared/hooks/useGoogleAnalytics.js